/**
 * 房间选择
 */
import React, { useMemo, memo } from 'react';
import { connect } from 'react-redux';
import { message, Select } from 'antd';
import intl from 'react-intl-universal';

import ReserveRoomItem from '@/components/Reservation/RoomItem';
import {
  createStateSelector,
  findItemByKey,
  getRoomCheckInStatus,
} from '@/redux/actions/reservation/helper';
import { handleRentItemChange } from '@/redux/actions/reservation/checkInByReserve';
import {
  ReducerState,
  ReserveCheckInRoomInfo,
  storeName,
} from '@/redux/reducers/reservation/checkInByReserve';

import { getPopupContainer } from '../../helper';
import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { rentRoomInfos, allRoomList } = state;
  return { rentRoomInfos, allRoomList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callRentItemChange: handleRentItemChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;
interface IProps {
  recordId: string;
}

const { Option } = Select;

const RoomSelector: React.FC<IProps & MapStateProps & MapDispatchProps> = (props) => {
  const { rentRoomInfos, allRoomList, recordId, callRentItemChange } = props;

  const handleRoomIdChange = (roomId: number) => {
    try {
      const rentItemInfo = findItemByKey(rentRoomInfos, 'indexId', recordId);
      const categoryData = findItemByKey(allRoomList, 'id', rentItemInfo.roomTypeId);
      const selectTarget = findItemByKey(categoryData.roomList, 'id', roomId);
      if (selectTarget) {
        if (getRoomCheckInStatus(selectTarget)) {
          callRentItemChange(recordId, {
            roomId: selectTarget.id,
            roomNo: selectTarget.roomNo,
          });
        } else {
          message.error(intl.get('reservation_error_room_dirty'));
        }
      }
    } catch (e) {
      //
    }
  };

  const selectInfo = useMemo(() => {
    const selectOptions = []; // 选项
    let currentInfo: ReserveCheckInRoomInfo;
    const checkedIdMap: { [roomId: string]: boolean } = {}; // 所有已选房间id
    rentRoomInfos.forEach((item) => {
      if (item.indexId === recordId) {
        currentInfo = item;
      } else {
        checkedIdMap[item.roomId] = true;
      }
    });
    if (currentInfo) {
      const { roomTypeId } = currentInfo;
      const categoryData = findItemByKey(allRoomList, 'id', roomTypeId);
      const subRoomList = categoryData ? categoryData.roomList || [] : [];
      subRoomList.forEach((item) => {
        const { id, roomNo } = item;
        if (checkedIdMap[id]) return; // 房间被其它地方选中了
        selectOptions.push(
          <Option value={id} label={roomNo} key={id} disabled={!getRoomCheckInStatus(item)}>
            <ReserveRoomItem data={item} showCalendar={false} />
          </Option>,
        );
      });
    }
    return {
      value: currentInfo ? currentInfo.roomId : null,
      selectOptions,
    };
  }, [allRoomList, rentRoomInfos, recordId]);

  return (
    <Select
      placeholder={intl.get('app_reservation_room_queue_no')}
      notFoundContent={intl.get('reservation_error_room_valid_null')}
      className={styles.roomNoSelector}
      popupClassName={styles.roomDropdownWrapper}
      value={selectInfo.value}
      getPopupContainer={getPopupContainer}
      onChange={handleRoomIdChange}
      optionLabelProp="label"
    >
      {selectInfo.selectOptions}
    </Select>
  );
};

export const RoomNoSelector = connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(RoomSelector));
